var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drug-siderbar"},[_c('van-sidebar',{on:{"change":_vm.handleChange},model:{value:(_vm.activeId.active),callback:function ($$v) {_vm.$set(_vm.activeId, "active", $$v)},expression:"activeId.active"}},_vm._l((_vm.category),function(item,key){return _c('van-sidebar-item',{key:key,attrs:{"title":item.name}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }